// Display-only rows: never add them to payroll totals, selections or payment APIs.
function missingLines(summary) {
    if (!summary || summary.period.status !== 'payroll_calculation') return [];
    const people = new Map();
    ((summary.analysis || {}).missing_rate_sources || []).forEach(source => {
        if (!source.employee_id) return;
        const id = Number(source.employee_id);
        if (!people.has(id)) people.set(id, {id: `missing-${id}`, employee_id: id,
            employee_name_snapshot: source.employee_name, _missingRate: true, workflow_status: 'missing_rate',
            calculated_amount_minor: null, final_amount_minor: null, calculation_details: {components: []}});
        people.get(id).calculation_details.components.push({...source});
    });
    return Array.from(people.values());
}

function displayRuns(summary) {
    const runs = (summary && summary.runs || []).map(run => ({...run, lines: run.lines.slice()}));
    const missing = missingLines(summary);
    if (!missing.length) return runs;
    // The enclosing run is only a visual grouping; an unpriced row has no currency or amount.
    if (runs.length === 1) runs[0].lines.push(...missing);
    else runs.push({id: 'missing-rates', _missingRates: true, currency: null, lines: missing, totals: {}});
    return runs;
}

module.exports = {missingLines, displayRuns};
